import { Box, FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC } from 'react';

type ToggleSwitchProps = {
  defaultValue: boolean;
  disabled?: boolean;
  label?: [string, string];
  onChange: (val: boolean) => void;
};

export const ToggleSwitch: FC<ToggleSwitchProps> = ({ defaultValue, disabled = false, label, onChange }) => (
  <Box
    css={{
      display: 'inline-block'
    }}
  >
    <FlexLayout
      alignItems="center"
      as="label"
      css={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        WebkitTapHighlightColor: 'transparent'
      }}
    >
      <input
        type="checkbox"
        defaultChecked={defaultValue}
        onChange={() => onChange(!defaultValue)}
        style={{
          display: 'none'
        }}
      />
      <Box
        as="i"
        css={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          width: '46px',
          height: '26px',
          backgroundColor: defaultValue && !disabled ? '#539E66' : '#e6e6e6',
          borderRadius: '23px',
          transition: 'all 0.3s linear'
        }}
      >
        <Box
          css={{
            position: 'absolute',
            left: 0,
            width: '42px',
            height: '22px',
            backgroundColor: '#fff',
            borderRadius: '11px',
            transform: `translate3d(${defaultValue ? '18px' : '2px'}, 0px, 0px) ${
              defaultValue ? 'scale3d(0, 0, 0)' : 'scale3d(1, 1, 1)'
            }`,
            transition: 'all 0.25s linear'
          }}
        />
        <Box
          css={{
            position: 'absolute',
            left: 0,
            width: '22px',
            height: '22px',
            backgroundColor: '#fff',
            borderRadius: '11px',
            boxShadow: '0 2px 2px rgba(0, 0, 0, 0.24)',
            transform: `translate3d(${defaultValue ? '22px' : '2px'}, 0px, 0)`,
            transition: 'all 0.2s ease-in-out'
          }}
        />
      </Box>
      {label && (
        <H4 fontWeight="semiBold" ml="xs" color={disabled ? 'secondary' : 'primaryText'}>
          {defaultValue ? label[0] : label[1]}
        </H4>
      )}
    </FlexLayout>
  </Box>
);
